/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_UploadingInputs */



/**
* | output |
* | --- |
* | "Importing..." |
*
* @param {Archon_UploadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_uploading = /** @type {((inputs?: Archon_UploadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_UploadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione in corso...")
	return /** @type {LocalizedString} */ ("Importing...")
});